<body class="d-flex flex-column h-100">
	<!-- Begin page content -->
	<main class="flex-shrink-0">
		<div class="container">
			<!-- Guide -->
			<section id="guide" style="padding: 60px 0;">
				<div class="guide-content">
					<div class="container">
						<div class="row mt-3">
							<div class="col-lg-4">
								<span translate class="title">kazakhstan.nav_leaderships</span>
							</div>
							<div class="col">
								<div class="line"></div>
							</div>
						</div>
            <div class="row mt-4">
              <div class="col-lg-6 col-md-6 mb-3" *ngFor="let item of leadershipList">
                <div class="box1" (click)="redirectGuideItem(item)">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="info">
                        <div class="row">
                          <div class="col-lg-2">
                            <img src="../../assets/img/3.png" alt="" style="margin: 20px 0;">
                          </div>
                          <div class="col-lg-3 portrait">
                            <!-- <img src="../../assets/img/44.png" alt=""> -->
                            <img style="width: 100%;" class="rounded-circle" src="{{item.image}}" alt="">
                            <!-- <img class="rounded-circle" alt="100x100" src="../../assets/img/3335.jpeg" data-holder-rendered="true"> -->

                            <!-- <img class="rounded-circle" alt="100x100"
                                src="https://mdbootstrap.com/img/Photos/Avatars/img%20(30).jpg" data-holder-rendered="true"> -->
                          </div>
                          <div class="col-lg-7 guide-title">
                            <span>{{item.name}}</span> <br>
                            <p>{{item.rank}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

					</div>
				</div>
			</section>
		</div>
	</main>
</body>
